<div id="demos-grid-container">
  <dx-toolbar *ngIf="!readonly" [items]="toolbarItemsValues"> </dx-toolbar>
  <dx-data-grid
    [rowAlternationEnabled]="true"
    [dataSource]="assets$ | async"
    [columns]="columnsAsset"
    keyExpr="id"
    [showBorders]="true"
    [selectedRowKeys]="selectedKeys"
    (onContentReady)="onGridContentReady($event)"
    [filterRow]="{
      visible: true
    }"
    height="100%"
  >
    <dxo-editing [allowUpdating]="!readonly" [allowDeleting]="!readonly" [useIcons]="true" newRowPosition="last"> </dxo-editing>
    <dxo-selection *ngIf="enableSelection" [allowSelectAll]="true" mode="multiple"></dxo-selection>
    <dxo-row-dragging [allowReordering]="!readonly" [onReorder]="onReorder"></dxo-row-dragging>
    <dxo-scrolling mode="standard"></dxo-scrolling>
    <dxo-paging [enabled]="false"></dxo-paging>
  </dx-data-grid>

  <dx-popup
    *ngIf="visible"
    title="Deletion"
    [hideOnOutsideClick]="true"
    [height]="250"
    [visible]="true"
    [width]="300"
    (onHiding)="hidePopup()"
  >
    <dxi-toolbar-item widget="dxButton" location="after" toolbar="bottom" [options]="deleteBtnOptions"> </dxi-toolbar-item>
    <dxi-toolbar-item widget="dxButton" location="after" toolbar="bottom" [options]="cancelBtnOptions"> </dxi-toolbar-item>
    <div *dxTemplate="let data of 'content'">
      Are you sure to delete <strong>{{ selectedRowToDelete.name }}?</strong>
    </div>
  </dx-popup>
  <dx-popup
    *ngIf="templateVisible"
    title="Can't delete"
    [hideOnOutsideClick]="true"
    [height]="280 + assetTemplates.lenght * 20"
    [visible]="true"
    [width]="400"
    (onHiding)="hidePopup()"
  >
    <dxi-toolbar-item widget="dxButton" location="after" toolbar="bottom" [options]="editTemplatesBtnOptions"> </dxi-toolbar-item>
    <dxi-toolbar-item widget="dxButton" location="after" toolbar="bottom" [options]="cancelBtnOptions"> </dxi-toolbar-item>
    <div *dxTemplate="let data of 'content'">
      <div>
        Demo <strong>{{ selectedRowToDelete.name }}</strong> can't be deleted because is connected to the following template:
      </div>
      <ul>
        <li *ngFor="let template of assetTemplates">
          <strong>{{ template.templateName }}</strong>
        </li>
      </ul>
      <div>Please, first update all the templates, then delete the demo asset.</div>
    </div>
  </dx-popup>
</div>

<div class="submitting" *ngIf="submitting">
  <div class="loader-container">
    <mat-progress-spinner diameter="60" mode="indeterminate" strokeWidth="5"></mat-progress-spinner>
  </div>
</div>
